import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import { Particle } from "../../components";
import amazonaImg from '../../Assets/projects/amazona.jpg'
import AlumniImg from '../../Assets/projects/Alumni.png'
import aiGalleryImg from '../../Assets/projects/aiGallery.png'
import antPanelImg from '../../Assets/projects/antPanel.png'
import portFolioImg from '../../Assets/projects/portfolio.png'
const projects = [
  {
    imgPath: amazonaImg,
    isBlog: false,
    title: "ShoppingMall",
    description: "An E-Commerce base project like amazon build with react.js, expressjs, mongodb and nodejs (MERN).Also in this project i have used redux for state management.",
    link: "https://github.com/harshit-kishor2/ShoppingMall",
  },
  {
    imgPath: AlumniImg,
    isBlog: false,
    title: "Alumni Management System",
    description: "This is a alumni management system which is build using java spring boot framework and jdbc template. For Security we use Spring security. This is complete authentication web based project. This project is used for only educational purpose.",
    link: "https://github.com/harshit-kishor2/AlumniManagementSystem",
  },
  {
    imgPath: aiGalleryImg,
    isBlog: false,
    title: "AI Gallery",
    description: <>
      This is a web gallery app where user can login and registration. After login user can visit on image gallery and make prediction of those images.
      For prediction I use tensor-flow library.
      <a
        href="https://web-gallery.netlify.app/gallery"
        target="_blank"
        rel="noreferrer"
        className="icon-colour"
      >
        {"  "}Visit Here
      </a>
    </>,
    link: "https://github.com/harshit-kishor2/Web-Gallery",
  },
  {
    imgPath: antPanelImg,
    isBlog: false,
    title: "Admin Panel with Ant Design",
    description: " This is an admin panel in which we implement a crud operation and authentication feature and layout is designed using Ant-Design.",
    link: "https://ant-design-harshit.netlify.app/",
  },
  {
    imgPath: portFolioImg,
    isBlog: false,
    title: "My Portfolio",
    description: " This is portfolio. It is a static website build using react js.",
    link: "https://harshit-resume.netlify.app/",
  },

]
const Projects = () => {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          {
            projects.map((project, i) => {
              return (
                <Col md={4} className="project-card">
                  <ProjectCard
                    imgPath={project.imgPath}
                    isBlog={project.isBlog}
                    title={project.title}
                    description={project.description}
                    link={project.link}
                  />
                </Col>
              )
            })
          }
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
